export const txtExedUpload =
  "This file cannot be uploaded because it exceeds the maximum allowed file size (2MB)";
